import TEST_EMAIL_DOMAINS from '@features/post-registration/constants/test-email-domains';

export const isTestUser = user =>
  TEST_EMAIL_DOMAINS.some(emailDomain => user.email?.includes(emailDomain));
